import { CheckCircle2, Circle, Pencil, Trash2, Check } from 'lucide-react';
import { useState } from 'react';

type Task = { id:number; title:string; assignee:string; done:boolean; dueDate?:string };

export function TaskSection({ label, list, onToggle, onEdit, onDelete, onCycle }:{ label:string; list:Task[]; onToggle:(id:number)=>void; onEdit:(id:number,title:string)=>void; onDelete:(id:number)=>void; onCycle:(id:number)=>void; }) {
  const [editingId, setEditingId] = useState<number | null>(null);
  const [editValue, setEditValue] = useState('');

  if (!list.length) return null;

  return <section className='mb-8'>
    <h2 className='mb-3 text-lg font-semibold text-slate-700 rounded-xl px-3 py-2 bg-slate-50 border border-slate-100 inline-block'>{label}</h2>
    <div className='space-y-3'>
      {list.map(task => <div key={task.id} className='flex items-center rounded-2xl border border-slate-100 bg-white p-4 shadow-sm'>
        <button onClick={() => onToggle(task.id)}>{task.done ? <CheckCircle2 className='text-green-600'/> : <Circle className='text-slate-400'/>}</button>
        <div className='ml-4 flex-1'>
          {editingId === task.id ? (
            <div className='flex gap-2'>
              <input value={editValue} onChange={(e)=>setEditValue(e.target.value)} className='w-full rounded border px-2 py-1'/>
              <button onClick={()=>{onEdit(task.id, editValue); setEditingId(null);}}><Check className='h-4 w-4 text-green-600'/></button>
            </div>
          ) : (
            <>
              <div className='font-medium text-slate-800'>{task.title}</div>
              <div className='mt-1 flex items-center gap-2 text-xs text-slate-500'>
                <button onClick={() => onCycle(task.id)} className='rounded-full bg-sky-100 text-sky-800 px-2 py-1 border border-sky-200'>{task.assignee}</button>
                {task.dueDate && <span>Due {task.dueDate}</span>}
              </div>
            </>
          )}
        </div>
        <button onClick={() => { setEditingId(task.id); setEditValue(task.title); }} className='p-2'><Pencil className='h-4 w-4 text-slate-500'/></button>
        <button onClick={() => onDelete(task.id)} className='p-2'><Trash2 className='h-4 w-4 text-red-400'/></button>
      </div>)}
    </div>
  </section>;
}